export default "__VITE_ASSET__BkDLoKf7__"